import { ShieldCheck } from 'lucide-react';

import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger
} from '@/components/ui/tooltip';

export function RlsNoticePill() {
    return (
        <TooltipProvider delayDuration={100}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span
                        tabIndex={0}
                        aria-label="Turns on row-level security"
                        className="inline-flex items-center gap-1.5 bg-sky-500/10 px-2.5 border border-sky-500/40 rounded-full h-6 text-sky-700 dark:text-sky-400 text-xs whitespace-nowrap cursor-default"
                    >
                        <ShieldCheck className="size-3.5" />
                        Turns on RLS
                    </span>
                </TooltipTrigger>
                <TooltipContent side="top" className="max-w-64">
                    <p className="font-medium">Returns user-specific data</p>
                    <p className="opacity-80 mt-1">
                        Adding this server turns on row-level security for the
                        agent. Scheduled jobs that use the agent must then be
                        private.
                    </p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
